import $ from "cash-dom"
;(() => {
  const ACTIVE = "dropdown-container_active"
  const OPEN_BY_HOVER_TIMER = 1200

  window.toggleDropdown = (container, addOrRemove) => {
    container.toggleClass(ACTIVE, addOrRemove)
    if (container.hasClass(ACTIVE)) {
      container.trigger("dropdown:shown")
    }
  }

  const closeActive = () => {
    $(`.${ACTIVE}`).removeClass(ACTIVE)
  }

  window.initDropdowns = (dropdowns) => {
    dropdowns.each(function initDropdown() {
      const container = $(this)

      $(document).on(
        "document:click document:keyup:escape",
        (event, target) => {
          if (!container[0].contains(target)) {
            window.toggleDropdown(container, false)
          }
        },
      )

      const toggler = container.find(".dropdown-current")
      let timeout = null

      toggler.on({
        click() {
          window.toggleDropdown(container)
        },
        mouseenter() {
          timeout = setTimeout(() => {
            closeActive()
            window.toggleDropdown(container, true)
          }, OPEN_BY_HOVER_TIMER)
        },
        mouseleave() {
          clearTimeout(timeout)
        },
      })
    })
  }

  $(() => {
    window.initDropdowns($(".dropdown-container"))

    // Expand dropdown to show all items
    $("body").on(
      "click",
      ".dropdown-i-link_expand",
      function togglePrimary(event) {
        event.preventDefault()
        $(this).closest(".dropdown").toggleClass("dropdown_primary")
      },
    )
  })
})()
